import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.EntregaZERealizadaDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
export const columnasFijas: Column[] = [
    { title: "Folio viaje ZE", cell: x => ({ data: x.FolioViajeZE }) },
    { title: "Fecha", cell: x => ({ data: kea.formatDate(x.Fecha) }) },
    { title: "Dirección", cell: x => ({ data: x.Direccion }) },
    { title: "Proveedor", cell: x => ({ data: x.NombreProveedorZE }) },
    { title: "Chofer", cell: x => ({ data: x.NombreChoferZE }) },
    { title: "Guias entregadas", cell: x => ({ data: x.CantGuiasEntregadas }) },
    { title: "Guias no entregadas", cell: x => ({ data: x.CantGuiasRechazadas }) },
];

export interface BotonesListaDeps {
    onVer: (x: Entity) => void;
}
/**Obtiene las columnas del grid */
export function columnas(deps: BotonesListaDeps, permisos: models.Rol): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones<Entity>([
        {
            onClick: x => deps.onVer(x),
            tooltip: "Ver",
            iconClass: fa("eye"),
        }
    ]);

    return [
        botones,
        ...columnasFijas
    ];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/entregasZERealizadas/list/columns.tsx